import { CustomerBox } from "@/features/product-and-price/info-boxes/types";

/**
 * Whether an account can be given a parent.
 *
 * Adding is offered whatever the account is and disabled rather than
 * hidden when it cannot, so the page reads the same from every account.
 *
 * It is read off the relations themselves - what hangs below the account -
 * rather than off the isParent flag, which stays set on an account whose
 * last child has since left. An account like that stands alone and has to
 * be treatable that way.
 *
 * Ending and deleting a parent are per-stretch and live on the rows, so
 * they are decided by parentStretchState rather than here.
 */
const hasChildren = (customer: CustomerBox) =>
  customer.childCustomers.length > 0;

/**
 * Anything without children of its own. An account that already has a
 * parent can still be added to another - that is how a parent is changed,
 * and the backend ends the old stretch when the new one starts. What an
 * account cannot be is a parent and a child at once, so having children is
 * the only thing that rules adding out.
 */
export const canAddParent = (customer: CustomerBox): boolean =>
  !hasChildren(customer);
